import React from 'react'

// A password field is deliberately UNCONTROLLED.
//
// React 18 syncs a controlled input's value into the DOM `value` ATTRIBUTE, not just the
// property, so a controlled password field renders in DevTools as:
//     <input type="password" value="theActualPassword">
// and the password sits in plain sight in the Elements panel. Omitting the `value` prop leaves
// React nothing to sync, and the element stays <input type="password">.
//
// The typed value still reaches the parent through onChange, so nothing about the form logic
// changes. The trade-off is that an uncontrolled input cannot be cleared by setting state - it
// only resets when the component unmounts. That is fine here: no password field in this app is
// cleared programmatically while mounted.
//
// This is a shoulder-surfing / screen-share / screenshot fix, not a security boundary. Anyone
// at the keyboard can still read the value from the console with $0.value - that is true of
// every login form on the web and cannot be prevented.
const Primaryinput = ({Lable, Type, Value, setInput, onkeyPress}) => {
  const isPassword = Type === 'password';
  return (
    <div className='public_primary_input_wrapper'>
      {Lable &&
        <label>{Lable}</label>
      }
      <div className='public_primary_input_container'>
        <input 
          type={Type}
          {...(isPassword ? {} : {value: Value})}
          placeholder={Lable} 
          onChange={(e)=> setInput(e.target.value)}
          onKeyPress={onkeyPress}
        />
      </div>
    </div>
  )
}

export default Primaryinput
